import { render, staticRenderFns } from "./customer-type-button-group.vue?vue&type=template&id=645d1dcd&scoped=true&"
import script from "./customer-type-button-group.vue?vue&type=script&lang=js&"
export * from "./customer-type-button-group.vue?vue&type=script&lang=js&"
import style0 from "./customer-type-button-group.vue?vue&type=style&index=0&id=645d1dcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645d1dcd",
  null
  
)

export default component.exports